import { setDataLayer } from "../../defaults/gtm";
import { pushToMixPanel, pushToMixPanelImmediate } from "../../defaults/mixPanel";

export const useEventsTrack = (prefix) => {
  const prefixDefault = `${process.env.NX_PUBLIC_PRODUCT_NAME || 'EVENT'}_`;

  const eventPrefix = prefix || prefixDefault;

  const sendEventSegment = async (event, data, type) => {
    const eventName = `${eventPrefix}${event}`;
    await window.analytics[type](eventName, data);
  };

  const sendEventGTM = (event, data, dataLayerName) => {
    const eventName = `${eventPrefix}${event}`;
    setDataLayer({ event: eventName, ...data }, dataLayerName);
  };

  // One derivation for both the batched and the immediate path: two copies of
  // this expression would let the same call site land under two event names.
  const mixPanelEventName = (event) =>
    `${eventPrefix.toLowerCase()}_${event.replaceAll(/([a-z])([A-Z])/g, '$1_$2').toLowerCase()}`;

  const sendEventMixPanel = (event, data) => {
    pushToMixPanel({ event: mixPanelEventName(event), ...data });
  };

  const trackGTM = (event, data = {}, dataLayerName = 'dataLayer') => sendEventGTM(event, data, dataLayerName);
  const trackMixPanel = (event, data = {}) => sendEventMixPanel(event, data);
  const trackMixPanelImmediate = (event, data = {}) =>
    pushToMixPanelImmediate({ event: mixPanelEventName(event), ...data });
  const trackSegment = async (event, data = {}) => await sendEventSegment(event, data, 'track');
  const trackPageSegment = async (event, data = {}) => await sendEventSegment(event, data, 'page');
  const trackIdentify = (identify) => window.analytics.identify(identify);

  return {
    trackSegment,
    trackGTM,
    trackPageSegment,
    trackIdentify,
    trackMixPanel,
    trackMixPanelImmediate,
  };
};
